import {Injectable} from "@angular/core";

@Injectable()
export class SessionStorageService {
    constructor() {
    }

    setItem(key: string, item: any) {
        sessionStorage.setItem(key, JSON.stringify(item));
        return true;
    }

    getItem(key: string): any {
        return JSON.parse(sessionStorage.getItem(key));
    }

    clear(): void {
        sessionStorage.clear();
    }
}
